import { Injectable, inject, Inject, LOCALE_ID } from '@angular/core';
import { ListRecordsService } from '../record/list-records.service';
import { GetRecordService } from '../record/get-record.service';
import { RecordData, QuestionnaireAnswer, TypesUtils } from '../../types';
import { GostUtils } from '../../features/home/cards/recordings/gost-utils';
import { GENERATE_PDF_DATA_SERVICE_I18N } from './generate-pdf-data.service.i18n';

// レコード情報からPDF出力データを生成するサービス
@Injectable()
export class GeneratePdfDataService {

  private ocResults = [
    { name: 'OC_TEETH', description: GENERATE_PDF_DATA_SERVICE_I18N.ocResults.teeth.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.ocResults.teeth.values.lessThan10, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.teeth.values.between10And20, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.teeth.values.between21And25, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.teeth.values.moreThan25] },
    { name: 'OC_DENTURE', description: GENERATE_PDF_DATA_SERVICE_I18N.ocResults.denture.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.ocResults.denture.values.slip, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.denture.values.movement, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.denture.values.stable, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.denture.values.notUsed] },
    { name: 'OC_ORAL_HYGIENE', description: GENERATE_PDF_DATA_SERVICE_I18N.ocResults.oralHygiene.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.ocResults.oralHygiene.values.severeContamination, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.oralHygiene.values.contamination, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.oralHygiene.values.tongueCoatingCaries, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.oralHygiene.values.noContamination] },
    { name: 'OC_ARTICULATION_LEVEL', description: GENERATE_PDF_DATA_SERVICE_I18N.ocResults.articulationLevel.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.ocResults.articulationLevel.values.unintelligible, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.articulationLevel.values.sometimes, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.articulationLevel.values.sometimesNot, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.articulationLevel.values.clear] },
    { name: 'OC_RIGHT_ARM', description: GENERATE_PDF_DATA_SERVICE_I18N.ocResults.rightArm.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.ocResults.rightArm.values.almostImmobile, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.rightArm.values.canElevate, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.rightArm.values.weakResistance, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.rightArm.values.strongResistance] },
    { name: 'OC_LEFT_ARM', description: GENERATE_PDF_DATA_SERVICE_I18N.ocResults.leftArm.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.ocResults.leftArm.values.almostImmobile, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.leftArm.values.canElevate, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.leftArm.values.weakResistance, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.leftArm.values.strongResistance] },
    { name: 'OC_DISABILITY_LEVEL', description: GENERATE_PDF_DATA_SERVICE_I18N.ocResults.disabilityLevel.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.ocResults.disabilityLevel.values.bedridden, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.disabilityLevel.values.wheelchair, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.disabilityLevel.values.bedboundWalkable, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.disabilityLevel.values.independent] },
    { name: 'OC_COGNITIVE_LEVEL', description: GENERATE_PDF_DATA_SERVICE_I18N.ocResults.cognitiveLevel.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.ocResults.cognitiveLevel.values.requiresMonitoring, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.cognitiveLevel.values.prominent, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.cognitiveLevel.values.occasional, GENERATE_PDF_DATA_SERVICE_I18N.ocResults.cognitiveLevel.values.noSymptoms] }
  ];

  private gcResults = [
    { name: 'GC_CONSCIOUSNESS_LEVEL', description: GENERATE_PDF_DATA_SERVICE_I18N.gcResults.consciousnessLevel.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.gcResults.consciousnessLevel.values.noResponse, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.consciousnessLevel.values.painResponse, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.consciousnessLevel.values.voiceResponse, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.consciousnessLevel.values.awake] },
    { name: 'GC_TEMPERATURE', description: GENERATE_PDF_DATA_SERVICE_I18N.gcResults.temperature.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.gcResults.temperature.values.over40, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.temperature.values.between385And399, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.temperature.values.between375And384, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.temperature.values.under375] },
    { name: 'GC_PULSE_LEVEL', description: GENERATE_PDF_DATA_SERVICE_I18N.gcResults.pulseLevel.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.gcResults.pulseLevel.values.over130, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.pulseLevel.values.between111And130, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.pulseLevel.values.between91And110, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.pulseLevel.values.under90] },
    { name: 'GC_SPO2', description: GENERATE_PDF_DATA_SERVICE_I18N.gcResults.spo2.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.gcResults.spo2.values.under91, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.spo2.values.between92And93, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.spo2.values.between94And95, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.spo2.values.over96] },
    { name: 'GC_BREATH_LEVEL', description: GENERATE_PDF_DATA_SERVICE_I18N.gcResults.breathLevel.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.gcResults.breathLevel.values.over30, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.breathLevel.values.between25And29, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.breathLevel.values.between21And24, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.breathLevel.values.under20] },
    { name: 'GC_ON_OXYGEN', description: GENERATE_PDF_DATA_SERVICE_I18N.gcResults.onOxygen.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.gcResults.onOxygen.values.highFlow, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.onOxygen.values.lowFlow, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.onOxygen.values.tracheostomy, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.onOxygen.values.none] },
    { name: 'GC_SPUTUM', description: GENERATE_PDF_DATA_SERVICE_I18N.gcResults.sputum.description, values: [GENERATE_PDF_DATA_SERVICE_I18N.gcResults.sputum.values.frequentSuction, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.sputum.values.suction, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.sputum.values.rattleSelfExpectoration, GENERATE_PDF_DATA_SERVICE_I18N.gcResults.sputum.values.none] }
  ];

  private mwstResults = [
    { value: 1, description: GENERATE_PDF_DATA_SERVICE_I18N.mwstResults.noSwallowWithCoughOrDyspnea },
    { value: 2, description: GENERATE_PDF_DATA_SERVICE_I18N.mwstResults.swallowWithDyspnea },
    { value: 3, description: GENERATE_PDF_DATA_SERVICE_I18N.mwstResults.swallowGoodBreathingWithCoughOrWetVoice },
    { value: 4, description: GENERATE_PDF_DATA_SERVICE_I18N.mwstResults.swallowGoodBreathingNoCough },
    { value: 5, description: GENERATE_PDF_DATA_SERVICE_I18N.mwstResults.swallowGoodBreathingNoCoughWithRepetitive },
  ];

  private foodResults = [
    { value: 1, description: GENERATE_PDF_DATA_SERVICE_I18N.foodResults.noSwallowWithCoughOrDyspnea },
    { value: 2, description: GENERATE_PDF_DATA_SERVICE_I18N.foodResults.swallowWithDyspnea },
    { value: 3, description: GENERATE_PDF_DATA_SERVICE_I18N.foodResults.swallowGoodBreathingWithCoughOrWetVoiceAndRetention },
    { value: 4, description: GENERATE_PDF_DATA_SERVICE_I18N.foodResults.swallowGoodBreathingNoCough },
    { value: 5, description: GENERATE_PDF_DATA_SERVICE_I18N.foodResults.swallowGoodBreathingNoCoughWithRepetitive },
  ];

  private scWoThicknessResults = ['1ml 1st', '1ml 2nd', '3ml 1st', '3ml 2nd', '5ml 1st', '5ml 2nd', '30ml', '100ml'];
  private scWithThicknessResults = ['1ml', '3ml', '5ml', '30ml'];

  private gostUtils = new GostUtils(); //@injectableでないので直接newする

  private gostRecordData;

  constructor(
    private listRecordsService: ListRecordsService,
    private getRecordService: GetRecordService,
    @Inject(LOCALE_ID) private locale: string = 'ja-JP',
  ) { }

  restReportData() {
    this.gostRecordData = null;
  }

  async getGOSTReportData(sectionId: string, userId: string, userreportDate: string): Promise<any> {
    if (this.gostRecordData !== null) return this.gostRecordData;

    const gostRecords = await this.listRecords(sectionId, userId, "GOST");
    const gostDataRecords = await this.listRecords(sectionId, userId, "GOST_Data");
    let records = [].concat(gostRecords, gostDataRecords);
    if (records && records.length > 0) {
      records = records
        .filter(record =>
          record.data?.createdAt &&
          (!userreportDate || record.data?.createdAt.slice(0, userreportDate.length) <= userreportDate) &&
          record.data?.version === "2") // gost-infos-cardを表示する条件
        .sort((a, b) => b.data.createdAt.localeCompare(a.data.createdAt));
    }
    if (!records || records.length == 0) {
      this.gostRecordData = [];
      return;
    }

    const targetRecordId = records[0].id;
    const recordData = await this.getRecordData(sectionId, targetRecordId);
    this.gostUtils.evaluateGost(recordData);
    this.gostRecordData = recordData;
    return this.gostRecordData;
  }

  async generateGOSTReportData(sectionId: string, userId: string, userreportDate: string): Promise<any> {
    const recordName = "GOST";
    const recordTitle = { ja: "食形態目安推奨テスト（GOST）", tw: "食物質地建議測試（GOST）", en: "Food Texture Recommendation Test (GOST)" };

    const recordData = await this.getGOSTReportData(sectionId, userId, userreportDate);
    if (!recordData || recordData.length == 0) return this.generateNotFoundReportData(recordName, recordTitle);

    const primarilySelectedFoods = recordData.data.PrimarilySelectedFoods.selectedFoods.sort((a, b) => a.rank - b.rank).slice(0, 2);
    let reportData = {};
    reportData[this.getRecordItemName(recordName, "protocol")] = recordData.data.recordTypeView;
    reportData[this.getRecordItemName(recordName, "asOfDate")] = recordData.data.asOfDate.split('-').join('/');
    reportData[this.getRecordItemName(recordName, "measurerName")] = recordData.meta.measurer.lastName + " " + recordData.meta.measurer.firstName;
    reportData[this.getRecordItemName(recordName, "filsGrade")] = String(recordData.data.filsGrade);
    reportData[this.getRecordItemName(recordName, "space1")] = "";
    let formatData = {
      visualizationType: "Record",
      visualizationSubType: "Normal",
      displayNames: { ja: "GOSTレコード", en: "GOST Record" },
      name: "gostrecord",
      description: "GOSTレコードの情報",
      dataItems: [
        this.makeFormatItem(recordName, "protocol", recordTitle, "Header1"),
        this.makeFormatItem(recordName, "measurerName", { ja: "計測者", tw: "測量者", en: "Examiner" }, "Header2"),
        this.makeFormatItem(recordName, "asOfDate", { ja: "評価日", tw: "評估日期", en: "Evaluation date" }, "Header3"),
        this.makeFormatItem(recordName, "filsGrade", { ja: "想定FILSレベル", tw: "預估FILS等級", en: "Estimated FILS level" }),
        this.makeFormatItem(recordName, "space1", { ja: "", en: "" }),
      ],

    };
    for (let i = 0; i < Math.min(2, primarilySelectedFoods.length); i++) {
      const itemName = "primarilySelectedFoodsRank" + String(i + 1);
      formatData.dataItems.push(
        this.makeFormatItem(recordName, itemName, { ja: primarilySelectedFoods[i].name })
      );
      reportData[this.getRecordItemName(recordName, itemName)] = "★".repeat(5 - primarilySelectedFoods[i].rank);

    };
    return { format: [formatData], data: reportData };

  }

  async generateGOSTDetailReportData(sectionId: string, userId: string, userreportDate: string): Promise<any> {
    const recordName = "GOST";
    const recordTitle = { ja: "食形態目安推奨テスト（GOST）詳細", tw: "食物質地建議測試（GOST）詳細資料", en: "Food Texture Recommendation Test (GOST) Details" };
    const recordData = await this.getGOSTReportData(sectionId, userId, userreportDate);
    if (!recordData || recordData.length == 0) return this.generateNotFoundReportData(recordName, recordTitle);
    const primarilySelectedFoods = recordData.data.PrimarilySelectedFoods.selectedFoods.sort((a, b) => a.rank - b.rank).slice(0, 2);

    let reportData = {};
    reportData[this.getRecordItemName(recordName, "protocol")] = recordData.data.recordTypeView;
    reportData[this.getRecordItemName(recordName, "asOfDate")] = recordData.data.asOfDate.split('-').join('/');
    reportData[this.getRecordItemName(recordName, "measurerName")] = recordData.meta.measurer.lastName + " " + recordData.meta.measurer.firstName;
    reportData[this.getRecordItemName(recordName, "filsGrade")] = String(recordData.data.filsGrade);

    let formatData = {
      visualizationType: "Record",
      visualizationSubType: "Normal",
      displayNames: { ja: "GOSTレコード詳細", en: "GOST Record Details" },
      name: "gostrecordDetil",
      description: "GOSTレコードの詳細情報",
      dataItems: [
        this.makeFormatItem(recordName, "protocol", recordTitle, "Header1"),
        this.makeFormatItem(recordName, "measurerName", { ja: "計測者", tw: "測量者", en: "Examiner" }, "Header2"),
        this.makeFormatItem(recordName, "asOfDate", { ja: "評価日", tw: "評估日期", en: "Evaluation date" }, "Header3"),
        this.makeFormatItem(recordName, "filsGrade", { ja: "想定FILSレベル", tw: "預估FILS等級", en: "Estimated FILS level" }),
        this.makeFormatItem(recordName, "space1", { ja: "", en: "" }),
      ],

    };
    for (let i = 0; i < Math.min(2, primarilySelectedFoods.length); i++) {
      const itemName = "primarilySelectedFoodsRank" + String(i + 1);
      formatData.dataItems.push(
        this.makeFormatItem(recordName, itemName, { ja: primarilySelectedFoods[i].name })
      );
      reportData[this.getRecordItemName(recordName, itemName)] = "★".repeat(5 - primarilySelectedFoods[i].rank);
    };

    let formatDataOC = this.makeOCGCDetailData("gostOCData", "Normal", { ja: "口腔機能と生活能力(OC)", tw: "口腔功能與生活能力(OC)", en: "Oral Function and Daily Living (OC)" }, recordData.data.gostOCData.metrics, this.ocResults, recordName, reportData);
    let formatDataGC = this.makeOCGCDetailData("gostGCData", "Normal", { ja: "全身状態(GC)", tw: "全身狀態(GC)", en: "General Condition (GC)" }, recordData.data.gostGCData.metrics, this.gcResults, recordName, reportData);
    let withoutThickness = this.makeGostSCDetailData("withoutThickness", { ja: "水飲みテスト", tw: "飲水測試", en: "Water Swallowing Test" }, recordData.data.gostSCData.withoutThicknessSteps, this.scWoThicknessResults, recordName, reportData);
    let scWithThickness = this.makeGostSCDetailData("withThickness", { ja: "水飲みテスト（トロミ）", tw: "飲水測試（增稠）", en: "Water Swallowing Test (Thickened)" }, recordData.data.gostSCData.withThicknessSteps, this.scWithThicknessResults, recordName, reportData);
    return { format: [formatData, withoutThickness, scWithThickness, formatDataGC, formatDataOC], data: reportData };

  }

  private colName2AmountAndRound(colName): [number, number] {
    // colNameには "1ml 1st" とか "30ml" とか入っているので、これをパースして amount と round を取得する
    var amount, roundNum;
    const match = colName.match(/(\d+)ml(?: (\d+))?/);
    if (match) {
      amount = parseInt(match[1]);
      roundNum = parseInt(match[2]) || 1;
    }

    return [amount, roundNum];
  }

  getScRound(steps, amount: number, roundNum: number) {
    var step = steps.find(s => s.amount == amount);
    if (!step) {
      step = { amount: amount, rounds: [] };
      steps.push(step);
    }

    var round = step.rounds.find(s => s.round == roundNum);
    if (!round) {
      round = { round: roundNum, isMeasured: false };
      step.rounds.push(round);
    }

    return round;

  }

  getSCTestResult(steps, colName: string) {
    let [amount, roundNum] = this.colName2AmountAndRound(colName);
    const round = this.getScRound(steps, amount, roundNum);
    if (!round.isMeasured) return ""; // not measured
    const convertedRound = this.gostUtils.evaluateScRound(round);
    switch (convertedRound["testResult"]) {
      case this.gostUtils.testResultDisp.good: return "〇";
      case this.gostUtils.testResultDisp.bad: return "✕";
      case this.gostUtils.testResultDisp.acceptable: return "△";
    }
    return "";
  }

  private makeGostSCDetailData(name, titleDisplayNames, metrics, results, recordName, reportData) {
    let formatData = {
      visualizationType: "RecordDetail",
      visualizationSubType: "Normal",
      displayNames: { ja: name + "レコード", en: name + " Record" },
      name: name + "record",
      description: name + "レコードの情報",
      dataItems: [
        this.makeFormatItem(recordName, "detailTitle", titleDisplayNames, "Header1"),
      ],
    };
    reportData[this.getRecordItemName(recordName, "detailTitle")] = "";

    for (let i = 0; i < results.length; i++) {
      const itemResult = results[i];
      const itemName = name + "metrices" + String(i + 1);
      formatData.dataItems.push(
        this.makeFormatItem(recordName, itemName, { ja: itemResult })
      );
      reportData[this.getRecordItemName(recordName, itemName)] = this.getSCTestResult(metrics, itemResult);
    }
    return formatData;
  }

  private makeOCGCDetailData(name, visualizationSubType, titleDisplayNames, metrics, results, recordName, reportData) {
    let formatData = {
      visualizationType: "RecordDetail",
      visualizationSubType: visualizationSubType,
      displayNames: { ja: name + "レコード", en: name + " Record" },
      name: name + "record",
      description: name + "レコードの情報",
      dataItems: [
        this.makeFormatItem(recordName, "detailTitle", titleDisplayNames, "Header1"),
      ],
    };
    reportData[this.getRecordItemName(recordName, "detailTitle")] = "";

    for (let i = 0; i < results.length; i++) {
      const itemResult = results[i];
      const itemName = name + "metrices" + String(i + 1);
      formatData.dataItems.push(
        this.makeFormatItem(recordName, itemName, { ja: itemResult.description })
      );
      const metric = metrics.find(x => x.code === itemResult.name);
      let scoreIndex = -1;
      if (metric) scoreIndex = metric.score + 3;
      if (scoreIndex >= 0 && scoreIndex < itemResult.values.length) {
        reportData[this.getRecordItemName(recordName, itemName)] = itemResult.values[scoreIndex];
      } else {
        reportData[this.getRecordItemName(recordName, itemName)] = "";
      }
    }
    return formatData;
  }

  async generateMWSTReportData(sectionId: string, userId: string, userreportDate: string): Promise<any> {
    const recordName = "MWST";
    const recordTitle = { ja: "改訂水飲みテスト（MWST）", tw: "改良飲水測試（MWST）", en: "Modified Water Swallowing Test (MWST)" };
    const mwstRecords = await this.listRecords(sectionId, userId, "MWST_G");
    const mwstDataRecords = await this.listRecords(sectionId, userId, "MWST_G_DATA");
    let records = [].concat(mwstRecords, mwstDataRecords);
    if (!records || records.length == 0) return this.generateNotFoundReportData(recordName, recordTitle);

    records = records
      .filter(record =>
        record.data?.createdAt &&
        (!userreportDate || record.data?.createdAt.slice(0, userreportDate.length) <= userreportDate))
      .sort((a, b) => b.data.createdAt.localeCompare(a.data.createdAt));

    if (!records || records.length == 0) return this.generateNotFoundReportData(recordName, recordTitle);

    const targetRecordId = records[0].id;
    const recordData = await this.getRecordData(sectionId, targetRecordId);
    let reportData = {};
    reportData[this.getRecordItemName(recordName, "protocol")] = recordData.data.recordTypeView;
    reportData[this.getRecordItemName(recordName, "measurerName")] = recordData.meta.measurer.lastName + " " + recordData.meta.measurer.firstName;
    reportData[this.getRecordItemName(recordName, "createdAt")] = new Date(recordData.data.createdAt).toLocaleDateString(this.locale);
    let formatData = {
      visualizationType: "Record",
      visualizationSubType: "Wide",
      displayNames: { ja: "MSWTレコード", en: "MWST Record" },
      name: "mswtrecord",
      description: "MSWTレコードの情報",
      dataItems: [
        this.makeFormatItem(recordName, "protocol", recordTitle, "Header1"),
        this.makeFormatItem(recordName, "measurerName", { ja: "計測者", tw: "測量者", en: "Examiner" }, "Header2"),
        this.makeFormatItem(recordName, "createdAt", { ja: "計測日", tw: "測量日期", en: "Measurement date" }, "Header3"),
      ],
    };

    for (let i = 0; i < this.mwstResults.length; i++) {
      const item = this.mwstResults[i];
      const itemName = "Score" + String(i);
      reportData[this.getRecordItemName(recordName, itemName)] = item.description;
      const checked = (i + 1) == recordData.data.finalScore ? "■" : "□";
      formatData.dataItems.push(this.makeFormatItem(recordName, itemName, { ja: checked + " 評点" + String(i + 1), tw: checked + " 評分" + String(i + 1), en: checked + " Score " + String(i + 1) }));
    }

    return { format: [formatData], data: reportData };
  }

  async generateFOOD_TESTReportData(sectionId: string, userId: string, userreportDate: string): Promise<any> {
    const recordName = "FOOD_TEST";
    const recordTitle = { ja: "フードテスト(Food Test)", tw: "食物測試(Food Test)", en: "Food Test" };
    const foodTestRecords = await this.listRecords(sectionId, userId, "FOOD_TEST_G");
    const foodTestDataRecords = await this.listRecords(sectionId, userId, "FOOD_TEST_G_DATA");
    let records = [].concat(foodTestRecords, foodTestDataRecords);
    if (!records || records.length == 0) return this.generateNotFoundReportData(recordName, recordTitle);

    records = records
      .filter(record =>
        record.data?.createdAt &&
        (!userreportDate || record.data?.createdAt.slice(0, userreportDate.length) <= userreportDate))
      .sort((a, b) => b.data.createdAt.localeCompare(a.data.createdAt));

    if (!records || records.length == 0) return this.generateNotFoundReportData(recordName, recordTitle);

    const targetRecordId = records[0].id;
    const recordData = await this.getRecordData(sectionId, targetRecordId);
    let reportData = {};
    reportData[this.getRecordItemName(recordName, "protocol")] = recordData.data.recordTypeView;
    reportData[this.getRecordItemName(recordName, "measurerName")] = recordData.meta.measurer.lastName + " " + recordData.meta.measurer.firstName;
    reportData[this.getRecordItemName(recordName, "createdAt")] = new Date(recordData.data.createdAt).toLocaleDateString(this.locale);
    let formatData = {
      visualizationType: "Record",
      visualizationSubType: "Wide",
      displayNames: { ja: "FOOD TESTレコード", en: "Food Test Record" },
      name: "foodtestrecord",
      description: "FOOD TESTレコードの情報",
      dataItems: [
        this.makeFormatItem(recordName, "protocol", recordTitle, "Header1"),
        this.makeFormatItem(recordName, "measurerName", { ja: "計測者", tw: "測量者", en: "Examiner" }, "Header2"),
        this.makeFormatItem(recordName, "createdAt", { ja: "計測日", tw: "測量日期", en: "Measurement date" }, "Header3"),
      ],
    };

    for (let i = 0; i < this.foodResults.length; i++) {
      const item = this.foodResults[i];
      const itemName = "Score" + String(i);
      reportData[this.getRecordItemName(recordName, itemName)] = item.description;
      const checked = (i + 1) == recordData.data.finalScore ? "■" : "□";
      formatData.dataItems.push(this.makeFormatItem(recordName, itemName, { ja: checked + " 評点" + String(i + 1), tw: checked + " 評分" + String(i + 1), en: checked + " Score " + String(i + 1) }));
    }

    return { format: [formatData], data: reportData };
  }

  async generateRSSTReportData(sectionId: string, userId: string, userreportDate: string): Promise<any> {
    const recordName = "RSST";
    const recordTitle = { ja: "反復唾液嚥下テスト(RSST)", tw: "反覆唾液吞嚥測試(RSST)", en: "Repetitive Saliva Swallowing Test (RSST)" };
    let records = await this.listRecords(sectionId, userId, "RSST");
    if (!records || records.length == 0) return this.generateNotFoundReportData(recordName, recordTitle);

    records = records
      .filter(record =>
        record.data?.createdAt &&
        (!userreportDate || record.data?.createdAt.slice(0, userreportDate.length) <= userreportDate))
      .sort((a, b) => b.data.createdAt.localeCompare(a.data.createdAt));

    if (!records || records.length == 0) return this.generateNotFoundReportData(recordName, recordTitle);

    const targetRecordId = records[0].id;
    const recordData = await this.getRecordData(sectionId, targetRecordId);
    let reportData = {};
    reportData[this.getRecordItemName(recordName, "protocol")] = recordData.data.recordTypeView;
    reportData[this.getRecordItemName(recordName, "measurerName")] = recordData.meta.measurer.lastName + " " + recordData.meta.measurer.firstName;
    reportData[this.getRecordItemName(recordName, "createdAt")] = new Date(recordData.data.createdAt).toLocaleDateString(this.locale);
    reportData[this.getRecordItemName(recordName, "numOfSwallowings")] = recordData.data.numOfSwallowings == null ? "" : String(recordData.data.numOfSwallowings) + " 回";
    reportData[this.getRecordItemName(recordName, "numOfCoughs")] = recordData.data.numOfCoughs == null ? "" : String(recordData.data.numOfCoughs) + " 回";
    let formatData = {
      visualizationType: "Record",
      visualizationSubType: "Normal",
      displayNames: { ja: "RSSTレコード", en: "RSST Record" },
      name: "rsstrecord",
      description: "RSSTレコードの情報",
      dataItems: [
        this.makeFormatItem(recordName, "protocol", recordTitle, "Header1"),
        this.makeFormatItem(recordName, "measurerName", { ja: "計測者", tw: "測量者", en: "Examiner" }, "Header2"),
        this.makeFormatItem(recordName, "createdAt", { ja: "計測日", tw: "測量日期", en: "Measurement date" }, "Header3"),
        this.makeFormatItem(recordName, "numOfSwallowings", { ja: "嚥下回数", tw: "吞嚥次數", en: "Swallow count" }),
        this.makeFormatItem(recordName, "numOfCoughs", { ja: "咳嗽・ムセ", tw: "咳嗽・嗆咳", en: "Coughing / choking" }),
      ],
    };

    return { format: [formatData], data: reportData };
  }

  generateNotFoundReportData(recordType: string, recordTitle) {
    let reportData = {};
    reportData[this.getRecordItemName(recordType, "protocol")] = recordType;
    reportData[this.getRecordItemName(recordType, "message")] = "";
    let formatData = {
      visualizationType: "Record",
      visualizationSubType: "Wide",
      displayNames: { ja: recordType + "レコード", en: recordType + " Record" },
      name: recordType + "record",
      description: recordType + "レコードの情報",
      dataItems: [
        this.makeFormatItem(recordType, "protocol", recordTitle, "Header1"),
        this.makeFormatItem(recordType, "message", { ja: "実施記録なし", tw: "無執行紀錄", en: "No records available" }),
      ],
    };
    return { format: [formatData], data: reportData };
  }

  async generateSSTPReportData(sectionId: string, userId: string, userreportDate: string): Promise<any> {
    const recordName = "SSTP";
    const recordTitle = { ja: "簡易飲水テスト(SSTP)", tw: "簡易飲水測試(SSTP)", en: "Simple Swallowing Test (SSTP)" };
    const sstpRecords = await this.listRecords(sectionId, userId, "SSTP");
    const sstpDataRecords = await this.listRecords(sectionId, userId, "SSTP_DATA");
    let records = [].concat(sstpRecords, sstpDataRecords);
    if (!records || records.length == 0) return this.generateNotFoundReportData(recordName, recordTitle);

    records = records
      .filter(record =>
        record.data?.createdAt &&
        (!userreportDate || record.data?.createdAt.slice(0, userreportDate.length) <= userreportDate))
      .sort((a, b) => b.data.createdAt.localeCompare(a.data.createdAt));

    if (!records || records.length == 0) return this.generateNotFoundReportData(recordName, recordTitle);

    const targetRecordId = records[0].id;
    const recordData = await this.getRecordData(sectionId, targetRecordId);
    const sstpPath = recordData.data?.sstpPath.path5ml === 'C' && (!recordData.data?.sstpPath.path30ml || recordData.data?.sstpPath.path30ml === 'C')
    let reportData = {};
    reportData[this.getRecordItemName(recordName, "protocol")] = recordData.data.recordTypeView;
    reportData[this.getRecordItemName(recordName, "measurerName")] = recordData.meta.measurer.lastName + " " + recordData.meta.measurer.firstName;
    reportData[this.getRecordItemName(recordName, "createdAt")] = new Date(recordData.data.createdAt).toLocaleDateString(this.locale);
    reportData[this.getRecordItemName(recordName, "sstpPath")] = sstpPath ? '☑' : '☐';
    let formatData = {
      visualizationType: "Record",
      visualizationSubType: "Normal",
      displayNames: { ja: "SSTPレコード", en: "SSTP Record" },
      name: "sstprecord",
      description: "SSTPレコードの情報",
      dataItems: [
        this.makeFormatItem(recordName, "protocol", recordTitle, "Header1"),
        this.makeFormatItem(recordName, "measurerName", { ja: "計測者", tw: "測量者", en: "Examiner" }, "Header2"),
        this.makeFormatItem(recordName, "createdAt", { ja: "計測日", tw: "測量日期", en: "Measurement date" }, "Header3"),
        this.makeFormatItem(recordName, "sstpPath", { ja: "安定した飲水", tw: "穩定飲水", en: "Stable drinking" }),
      ],
    };

    return { format: [formatData], data: reportData };
  }

  private listRecords(sectionId: string, userId: string, recordType: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.listRecordsService.listRecords(sectionId, userId, null, recordType, true).subscribe({
        next: (response) => {
          let records = (response as any);
          resolve(records);
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }

  private getRecordData(sectionId: string, recordiId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getRecordService.getRecord(recordiId, sectionId).subscribe({
        next: (res) => {
          var responseData = res as any;
          var result = TypesUtils.convertJsonToRecords([responseData], false);
          let record = result.records[0];

          resolve(record);
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }

  private getRecordData2(sectionId: string, userId: string, recordTypes: string[], userreportDate: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.listRecordsService.listRecords(sectionId, userId, null, null, true).subscribe({
        next: (response) => {
          let records = (response as any);
          if (records && records.length >= 1) {
            records = records
              .filter(record => recordTypes.includes(record.recordType) &&
                record.data?.createdAt &&
                (!userreportDate || record.data?.createdAt.slice(0, userreportDate.length) <= userreportDate))
              .sort((a, b) => b.data.createdAt.localeCompare(a.data.createdAt));
          }
          if (!records || records.length == 0) return null;
          const targetRecordId = records[0].id;
          this.getRecordService.getRecord(targetRecordId, sectionId).subscribe({
            next: (res) => {
              var responseData = res as any;
              var result = TypesUtils.convertJsonToRecords([responseData], false);
              let record = result.records[0];

              resolve(record);
            },
            error: (error) => {
              reject(error);
            }
          });
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }

  private getRecordItemName(recordName: string, name: string) {
    return recordName + "__" + name;
  }

  private makeFormatItem(recordName: string, name: string, displayNames: any, type: string = "Text") {
    return {
      name: this.getRecordItemName(recordName, name),
      displayNames: displayNames,
      enabled: true,
      type: type,
      require: false,
      showOnSummary: false,
    };
  }
}
